<header-web (dataEvent)='setLanguage($event)' [hotel]='true'></header-web>
<div class="w-100 px-0 margen-h">
  <div class="row mx-0 d-flex align-items-stretch">
    <div class="col-md-6 col-12 p-0 d-none d-md-block" style="position: relative;">
      <div id="backG">
        <img src="../../assets/image/recursos/pajaro.png" id="ufo">
        <!-- <img src="https://res.cloudinary.com/dylant25/image/upload/v1561062179/ufo.png" id="ufo"> -->
        <!-- <img src="https://res.cloudinary.com/dylant25/image/upload/v1561062179/ufo.png" id="ufo2"> -->
        <img src="../../assets/image/recursos/persona.png" id="ufo2">
        <div id=txtBox class="container text-center w-100">
          <p id="txtW">H</p>
          <p id="txtE0">O</p>
          <p id="txtL">T</p>
          <p id="txtC">E</p>
          <p id="txtO">L</p>
          <p id="txtM">E</p>
          <p id="txtE1">S</p>
          <h5 id="text-h"><small>Administra tu hotel de manera sencilla</small></h5>
        </div>
      </div>
      <!-- <section class="panel-bg bg-dark">
        <h1 class="title">SOFTWARE HOTELERO</h1>
        <h3 class="span loader subtitle"><span class="m">A</span><span class="m">D</span><span class="m">M</span><span
            class="m">I</span><span class="m">S</span><span class="m">T</span><span class="m">R</span><span
            class="m">A</span><span class="m">&nbsp;</span><span class="m">T</span><span class="m">U</span><span
            class="m">&nbsp;</span><span class="m">H</span><span class="m">O</span><span class="m">T</span><span
            class="m">E</span><span class="m">L</span><span class="m">&nbsp;</span><span class="m">F</span><span
            class="m">A</span><span class="m">C</span><span class="m">I</span><span class="m">L</span></h3>
      </section> -->
    </div>
    <div class="col-md-6 col-12 p-0" style="z-index: 0;">
      <div id="carouselExampleFade" class="carousel slide carousel-fade" data-bs-ride="carousel">
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img src="../../assets/image/galeria/Yachay.jpg" class="d-block w-100" alt="...">
          </div>
          <div class="carousel-item">
            <img src="../../assets/image/galeria/hotel.jpg" class="d-block w-100" alt="...">
          </div>
          <div class="carousel-item">
            <img src="../../assets/image/galeria/hotel-2.jpg" class="d-block w-100" alt="...">
          </div>
        </div>
        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  </div>
</div>
<section class="container-fluid mt-5">
  <div class="row">
    <div class="col-lg-6 offset-lg-3 col-md-8 col-md-2 col-12">
      <div class="container text-center">
        <h2 class="title fw-bold text-rojo">GESTIONA TU HOTEL O HOSPEDAJE</h2>
        <p class="text-justify text fw-bold text-lago lh-1 mb-2">Se trata de un software hotelero muy fácil de instalar
          y
          de usar, diseñado para hoteles y hospedajes medianos. Se trata de un SaaS (Software as a Service), lo que
          significa que está basado “en la nube”</p>
        <p class="text-center text fw-bold text-lago lh-1">Galileo ERP es un software de gestión hotelera rápido y fácil
          de usar, diseñado para hoteles y hospedajes medianos y grandes.</p>
      </div>
    </div>
  </div>
  <!-- <div class="container-fluid pb-5">
      <div class="flexing">
        <div class="section section--lake">
          <h3 class="title"><a class="text-decoration-none text-white" href="">CRONOGRAMA</a></h3>
        </div>
        <div class="section section--smoke">
          <h3 class="title"><a class="text-decoration-none text-white" href="">GESTIONA</a></h3>
        </div>
        <div class="section section--red">
          <h3 class="title">INVENTARIO</h3>
        </div>
        <div class="section section--bone">
          <h3 class="title">FACTURACION</h3>
        </div>
        <div class="section section--yellow">
          <h3 class="title">RESERVAS</h3>
        </div>
      </div>
    </div> -->
  <div class="w-100 py-5">
    <div class="row">
      <div class="col-10 offset-1">
        <div class="card mb-3 bg-lago">
          <div class="row g-0 d-flex align-items-center">
            <div class="col-md-7 order-2 order-md-1 text-center py-0">
              <img src="../../assets/image/galeria/hotel-1.png" class="img-fluid rounded-start" alt="...">
            </div>
            <div class="col-md-5 order-1 order-md-2">
              <div class="card-body">
                <h5 class="title text-center fw-bold text-white mb-3">CONTROLA TUS RESERVAS INDIVIDUALES Y GRUPALES EN
                  TU ESTABLECIMIENTO</h5>
                <ul class="subtitle lh-sm fw-bold text-white">
                  <li class="mb-2">¿Trabajas con agencias de turismo? No hay problema, puedes registrar reservas
                    grupales junto a la información de la agencia.</li>
                  <li class="mb-2">¿Tus huéspedes llegan independientemente? Registrarlos fácilmente desde el calendario
                    de reservas, registra sus datos y asígnales una habitación.</li>
                  <li>¿Trabajas con un meta buscador de viajes para reservas de alojamiento como Booking, Airbnb o
                    Despegar? Genial, podrás registrarlos en el sistema directamente diferenciando el origen del
                    huésped.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="card mb-3 bg-humo">
          <div class="row d-flex align-items-center g-0">
            <div class="col-md-5 order-1 order-md-1">
              <div class="card-body fw-bold">
                <h5 class="title text-center fw-bold text-dark mb-3">GESTIONA LA ACTIVIDAD DE TU HOTEL</h5>
                <ul class="subtitle text-dark fw-bold lh-1">
                  <li class="mb-2">Controla las reservas y sus detalles, registra huéspedes, consumos a la habitación,
                    ingresos y egresos, pagos, etc.</li>
                  <li class="mb-2">¿Sabes en que temporadas tienes mas huéspedes? Este sistema te ayudara a ver de
                    manera diaria, semanal, mensual cuantas personas se han hospedado en tu hotel, también que tipo de
                    habitaciones se han ocupado y que productos se han consumido.</li>
                </ul>
              </div>
            </div>
            <div class="col-md-7 order-2 order-md-2 text-center">
              <img src="../../assets/image/galeria/img-1.png" class="img-fluid rounded-start" alt="...">
            </div>
          </div>
        </div>
        <div class="card mb-3 bg-rojo">
          <div class="row d-flex align-items-center g-0">
            <div class="col-md-7 order-2 order-md-2 text-center py-0">
              <img src="../../assets/image/galeria/img-2.png" class="img-fluid rounded-start" alt="...">
            </div>
            <div class="col-md-5 order-1 order-md-1">
              <div class="card-body fw-bold text-white">
                <h5 class="title text-start fw-bold text-white mb-3">Gestión de huéspedes</h5>
                <ul class="subtitle text-start text lh-1">
                  <li class="mb-2">Controla el flujo entre las entradas y las salidas de existencias de los productos
                    que vendas.</li>
                  <li class="mb-2">Gestiona el estado de tus huéspedes, podrás tener un registro del check-in y
                    check-out, veras todos los detalles de la estadía de tus huéspedes.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="card mb-3 bg-hueso">
          <div class="row d-flex align-items-center g-0">
            <div class="col-md-5">
              <div class="card-body text-dark fw-bold">
                <h5 class="title text-center fw-bold text-dark mb-3">FACTURACIÓN Y PROVEEDORES</h5>
                <ul class="subtitle lh-1">
                  <!-- <li class="mb-2">Genera de forma automática y fácil comprobantes electrónicos tanto gravados como de exportación de servicios.</li> -->
                  <li class="mb-2">Genera de forma automática, rápida y fácil comprobantes electrónicos tanto gravados
                    como de exportación de servicios. Todo en uno.</li>
                </ul>
              </div>
            </div>
            <div class="col-md-7 text-center">
              <img src="../../assets/image/galeria/img-3.png" class="img-fluid rounded-start" alt="...">
            </div>
          </div>
        </div>
        <div class="card mb-3 bg-humo">
          <div class="row d-flex align-items-center g-0">
            <div class="col-md-7 order-2 order-md-1">
              <img src="../../assets/image/galeria/img-4.png" class="img-fluid rounded-start" alt="...">
            </div>
            <div class="col-md-5 order-1 order-md-2">
              <div class="card-body text-white fw-bold">
                <h5 class="title text-start fw-bold text-dark mb-3">MOTOR DE RESERVAS</h5>
                <ul class="subtitle text-dark lh-1">
                  <li class="mb-2">¿Tienes una página web? Si no la tienes podemos ayudarte con la creación de una, y
                    con ella tendrás la herramienta “MOTOR DE RESERVAS” para que tus huéspedes puedan consultar la
                    disponibilidad y precios de tus habitaciones desde tu pagina web.</li>
                  <li> También, tendrás la herramienta “PASARELA DE PAGOS” para que los huéspedes puedan realizar su
                    reserva y pagarla con tarjetas de crédito o débito, la cual automáticamente se registra en el panel
                    de reservas del sistema. Si ya cuentas con una pagina web, podemos integrar estas herramientas a tu
                    página.</li>
                  <!-- <li class="mb-2">Recibe reservas y pagos desde tu página web, los cuales son automáticamente integrados en el software.</li>
                    <li>Recibe notificaciones por correo de forma inmediata por nuevas reservas generadas.</li> -->
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="container mb-5">
  <div class="row mx-5 mb-5">
    <div class="col-md-10 offset-md-1 col-12 mb-5">
      <div class="row">
        <div class="col-12 text-center mb-2">
          <h2 class="fw-bold title text-lago">Mas de nuestro software</h2>
        </div>
        <div class="col-md-6 col-12 bg-humo pt-4">
          <ul class="text text-lago fw-bold text lh-sm">
            <li>Reportes de Rooming List.</li>
            <li>Reportes de ocupación.</li>
            <li>Gestión de cuentas por cobrar y pagar.</li>
            <li>Soporte permanente: Chat, Whatsapp, teléfono.</li>
          </ul>
        </div>
        <div class="col-md-6 col-12 bg-pantano pt-4">
          <ul class="text fw-bold text-humo lh-sm">
            <li>Manejo de distintos puntos de venta (Recepción, Restaurant, Bar, etc).</li>
            <li>Múltiples usuarios.</li>
            <li>Reporte de huéspedes.</li>
            <li>Reporte de cierre de caja.</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
<footer-web class="mt-5"></footer-web>
